<template>
  <b-container fluid>
    <b-card no-body>
      <b-card-header>
        <b-card-title>
          Unit overzicht <b-button :to="{name: 'UnitWizard'}">
            <i class="fa fa-magic" /> Unit wizard
          </b-button>
          <b-button 
            :disabled="isBusy" 
            class="pull-right btn-sm" 
            @click="getUnits()"
          >
            <i class="fa fa-refresh" /> Verversen units
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form-group description="*In beheer is inclusief losse inspecties en subbeheer">
          <b-input-group>
            <b-button-group>
              <b-button 
                v-for="item in count" 
                :key="item.value" 
                :disabled="isBusy" 
                :class="{'active': status == item.value,'btn-lg': true}" 
                variant="dark"
                @click="status = item.value"
              >
                {{ item.text }} 
                
                <b-badge 
                  v-if="!isBusy"
                  :variant="item.variant" 
                >
                  {{ item.count }}
                </b-badge>
                
                <b-spinner 
                  v-else 
                  small 
                  variant="light"
                />
              </b-button>
            </b-button-group>
            <b-radio-group 
              v-model="perPage" 
              :options="perPageOpties" 
              
              class="ml-2"
              size="lg" 
              buttons
            />

            <b-button 
              :disabled="isBusy" 
              variant="secondary" 
              class="ml-2 btn-lg" 
              
              
              @click="getUnits()"
            >
              <i class="fa fa-refresh" /> Vernieuwen
            </b-button>
          </b-input-group>
        </b-form-group>
        <b-form-row md-co>
          <b-col>
            <b-form-group label="Unitkenmerk">
              <b-form-input 
                v-model="zoekvelden.kenmerk" 
                debounce="200"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Relatie">
              <b-form-input 
                v-model="zoekvelden.relatie" 
                debounce="200"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Onderhoudsnummer">
              <b-form-input 
                v-model="zoekvelden.onderhoudsnummer" 
                debounce="200"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Keuringsnummer">
              <b-form-input 
                v-model="zoekvelden.keuringsnummer" 
                debounce="200"
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Adres">
              <b-form-input 
                v-model="zoekvelden.adres" 
                debounce="200"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Plaats">
              <b-form-input 
                v-model="zoekvelden.plaats" 
                debounce="200"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Onderhoudsfirma">
              <b-form-input 
                v-model="zoekvelden.onderhoudsfirma" 
                debounce="200"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Keuringsinstantie">
              <b-form-input 
                v-model="zoekvelden.keuringsinstantie" 
                debounce="200"
              />
            </b-form-group>
          </b-col>
        </b-form-row>
       
            
        <b-form-group>
          <b-form-checkbox-group
            v-model="zoekvelden.keuringsstatus"
            :options="keuringstatus"
            size="sm"
          />
        </b-form-group>
       
        <b-pagination
          v-model="currentPage"
          :total-rows="filteredUnits.length"
          :per-page="perPage"
          small
          responsive="sm"
          prev-text="Vorige"
          next-text="Volgende"
          limit="10"
          align="left"
        >
          <template #page="{ page, active }">
            <span v-if="active">Pagina {{ page }} van {{ Math.ceil(totalRows/perPage) }}</span>
            <span v-else>{{ page }}</span>
          </template>
        </b-pagination>

        <b-table
          :items="filteredUnits"
          :busy="isBusy"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          hover
          select-mode="single"
          bordered
          small
          responsive
          dark
          @row-selected="rowSelected"
        >
          <template #cell(UnitFoto)="row">
            <b-img-lazy
              v-if="row.item.Th"
              :src="fullThumbUrl(row.item.Th)"
              height="50"
              rounded
              center
            />
            <b-img 
              v-else 
              height="50" 
              center 
              rounded 
              src="img/placeholders/no-image-icon-0.jpg"
            />
          </template>
          <template #cell(GebouwFoto)="row">
            <b-img-lazy
              v-if="row.item.Ct"
              :src="fullThumbUrl(row.item.Ct)"
              height="50"
              rounded
              center
            />
            <b-img 
              v-else 
              height="50" 
              center 
              rounded 
              src="img/placeholders/no-image-icon-0.jpg"
            />
          </template>

          <template #cell(Unit)="row">
            {{ row.item.Uk }} ({{ row.item.Ti }}) {{ row.item.Kl }}
            <br>
            {{ row.item.Ad }}
            <br>
            {{ row.item.Po }} {{ row.item.Wp }}
            {{ row.item.Re }}<!--- {{row.item.Hs}}--->
            <br>
          </template>

          <template #cell(Of)="row">
            {{ row.item.Of }}&nbsp;
            <b-badge 
              v-if="row.item.On != ''" 
              variant="info"
            >
              nr. {{ row.item.On }}
            </b-badge>
          </template>

          <template #cell(Ki)="row">
            Keuringsdatum {{ row.item.Ka | formatDateTime( 'DD-MM-YYYY') }}
            <br>
            tot {{ row.item.Kd | formatDateTime( 'DD-MM-YYYY') }}
            <br>
            <KeuringsStatus 
              :status="row.item.As" 
              :deadline="new Date(row.item.Kd)"
            />
            door {{ row.item.Ki }} <b-badge 
              v-show="row.item.Kn !== 'Onbekend'" 
              variant="info"
            >
              nr. {{ row.item.Kn }}
            </b-badge>
          </template>

          <template #cell(Ac)="row">
            <b-button-group>
              <b-button :to="{name: 'UnitViewRoute',params: {id: row.item.Id}}">
                <i class="cui-dashboard" /> Algemeen
              </b-button>
              <b-button :to="{name: 'Inventarisatie',params: {id: row.item.Id}}">
                <i class="fa fa-list" /> Inventarisatie
              </b-button>
              <b-button :to="{name: 'Prognoses',params: {id: row.item.Id}}">
                <i class="fa fa-cog" /> Prognoses
              </b-button>
              <b-button :to="{name: 'Fotoboek',params: {id: row.item.Id}}">
                <i class="fa fa-photo" /> Foto's
              </b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-card-body>
      <b-card-footer>
        <nav>
          <b-pagination
            v-model="currentPage"
            :total-rows="filteredUnits.length"
            :per-page="perPage"
            small
            responsive="sm"
            prev-text="Vorige"
            next-text="Volgende"
            limit="10"
            align="left"
          >
            <template #page="{ page, active, numberOfpages }">
              <span v-if="active">Pagina {{ page }} van {{ Math.ceil(totalRows/perPage) }}</span>
              <span v-else>{{ page }}</span>
              <span>{{ numberOfpages }}</span>
            </template>
          </b-pagination>
        </nav>
      </b-card-footer>
    </b-card>
  </b-container>
</template>
<script>
import KeuringsStatus from '../../components/KeuringsStatus.vue';
import { keuringMixin } from '../../mixins/keuringMixin';
export default {
    name: "UnitsOverzicht",
    components: { KeuringsStatus },
    mixins: [ keuringMixin],
    data() {
        return {
            status: 1,
            count: [
              { text: "Uit contract", value: 0, variant: "warning", count: 0},
              { text: "In beheer", value: 1, variant: "success", count: 0},
              { text: "Subbeheer", value: 2, variant: "warning", count: 0},
              { text: "Losse inspectie", value: 3, variant: "info", count: 0}
            ],
            zoekvelden: {
                kenmerk: "",
                adres: "",
                plaats: "",
                relatie: "",
                onderhoudsnummer: "",
                onderhoudsfirma: "",
                keuringsnummer: "",
                keuringsinstantie: "",
                keuringsstatus: [-3, -2, -1, 0, 1,],
            },
            fields: [
                { label: "Unit", key: "UnitFoto" },
                { label: "Gebouw", key: "GebouwFoto" },
                "Unit",
                { label: "Onderhoudsfirma", key: "Of" },
                { label: "Keuring", key: "Ki" },
                { label: "Acties", key: "Ac" },
            ],
            units: [],
            isBusy: false,
            currentPage: 1,
            perPage: 15,
            perPageOpties: [15, 30, 60, 90],
            zoekterm: null,
        };

    },
    computed: {
        statusfilterOpties() {
          return this.count.map((el) => ({ value: el.value, text: el.text  + ' ' + el.count }));
        },
        statusTitel() {
          return this.statusfilterOpties.find((el) => el.value == this.status).text;
        },
        statusfilter() {
          if (this.status > 1 ) return 1;
          if (this.status < 1 ) return 0;
        },
        filteredUnits: function () {
            var result = this.units.filter((item) => this.zoekvelden.keuringsstatus.includes(item.As));
            result = result.filter((item) => item.Hs == this.status);
            if (this.zoekvelden.kenmerk !== '')
                result = result.filter((item) => item.Uk.toLowerCase().search(this.zoekvelden.kenmerk.toLowerCase()) > -1);
            if (this.zoekvelden.relatie !== '')
                result = result.filter((item) => item.Kl.toLowerCase().search(this.zoekvelden.relatie.toLowerCase()) > -1);
            if (this.zoekvelden.adres !== '')
                result = result.filter((item) => item.Ad.toLowerCase().search(this.zoekvelden.adres.toLowerCase()) > -1);
            if (this.zoekvelden.plaats !== '')
                result = result.filter((item) => item.Wp.toLowerCase().search(this.zoekvelden.plaats.toLowerCase()) > -1);
            if (this.zoekvelden.keuringsnummer !== '')
                result = result.filter((item) => item.Kn.toLowerCase().search(this.zoekvelden.keuringsnummer.toLowerCase()) > -1);
            if (this.zoekvelden.keuringsinstantie !== '')
                result = result.filter((item) => item.Ki.toLowerCase().search(this.zoekvelden.keuringsinstantie.toLowerCase()) > -1);
            if (this.zoekvelden.onderhoudsnummer !== '')
                result = result.filter((item) => item.On.toLowerCase().search(this.zoekvelden.onderhoudsnummer.toLowerCase()) > -1);
            if (this.zoekvelden.onderhoudsfirma !== '')
                result = result.filter((item) => item.Of.toLowerCase().search(this.zoekvelden.onderhoudsfirma.toLowerCase()) > -1);
            return result;
        },
        totalRows: function () {
            return this.filteredUnits.length;
        },
    },
    watch: {
        status(newValue, oldValue) {
            if (newValue == 0 && oldValue > 0 || newValue > 0 && oldValue == 0) {
              this.getUnits();
            }
        },
    },
    mounted() {
        this.getUnits();
    },
    methods: {
        rowSelected(record) {
            console.log(record);
            this.$router.push({ name: "UnitViewRouter", params: { id: record.Id } });
        },
        cerificaat(status) {
            return this.keuringstatus.find((el) => el.value == status).text;
        },
        fullThumbUrl(relativePath) {
            return ("https://res.cloudinary.com/transplan/image/upload/t_thumb" + relativePath);
        },
        getUnits() {
            var vm = this;
            this.isBusy = true;
            this.$http
                .get("/units/zoeken/" + this.status, {
                headers: {
                    token: vm.$store.state.token,
                },
                onDownloadProgress: function (progressEvent) {
                    console.log("download", progressEvent);
                },
            })
                .then(function (response) {
                console.log(response.data.units.length);
                vm.units = response.data.units;                
                if (response.data.count) {
                  console.log(response.data.count);
                    vm.count = response.data.count;
                }
                vm.isBusy = false;
            })
                .catch(function (error) {
                console.log(error);
            });
        },
    },
};
</script>